import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/observable/of';
import { catchError } from 'rxjs/operators';
import { UCInflection_CAT_WornLimitsVM, UCLinear_LIEBHERR_WornLimitsVM, UCPolynomial_KOMATSU_WornLimitsVM, UCStepped_ITM_WornLimitsVM, UCWornLimitGenericIdNameVM, UC_WornLimitInfoVM, USCOPopulateData, USCO_PartInfoVM } from './uc-setup-worn-limit.module';

@Injectable()
export class UcSetupWornLimitService {
  private readonly API_BASE = 'api/UndercarriageWornLimit/';
  private readonly GET_WORN_LIMIT_MODELS = this.API_BASE + 'GETUCWornLimitModels';
  private readonly GET_WORN_LIMIT_MAKES = this.API_BASE + 'GETUCWornLimitMakes';
  private readonly GET_WORN_LIMIT_COMPART_TYPE = this.API_BASE + 'GETUCWornLimitCompartTypes';
  private readonly GET_WORN_LIMIT_COMPARTS = this.API_BASE + 'GETUCWornLimitComparts';
  private readonly GET_WORN_LIMIT_TRACK_TOOL = this.API_BASE + 'GETUCWornLimitTrackTools';
  private readonly GET_WORN_LIMIT_CALC_METHODS = this.API_BASE + 'GETUCWornLimitCalcMethods';
  private readonly GET_WORN_LIMIT_COMPART_INFO = this.API_BASE + 'GetCompartUCWornLimitInfo';

  private readonly UPDATE_WORN_LIMIT_STEPPED_INFO = this.API_BASE + 'UpdateSteppedWornLimit';
  private readonly ADD_NEW_WORN_LIMIT_STEPPED_INFO = this.API_BASE + 'AddNewSteppedWornLimitDetails';

  private readonly UPDATE_WORN_LIMIT_INFLECTION_INFO = this.API_BASE + 'UpdateInflectionWornLimit';
  private readonly ADD_NEW_WORN_LIMIT_INFLECTION_INFO = this.API_BASE + 'AddNewInflectionWornLimitDetails';
  
  private readonly UPDATE_WORN_LIMIT_LINEAR_INFO = this.API_BASE + 'UpdateLinearWornLimit';
  private readonly ADD_NEW_WORN_LIMIT_LINEAR_INFO = this.API_BASE + 'AddNewLinearWornLimitDetails';

  private readonly UPDATE_WORN_LIMIT_POLYNOMIAL_INFO = this.API_BASE + 'UpdatePolynomialWornLimit';
  private readonly ADD_NEW_WORN_LIMIT_POLYNOMIAL_INFO = this.API_BASE + 'AddNewPolynomialWornLimitDetails';
  

  
  constructor(private _http: HttpClient) { }


  public GETUCWornLimitModels(): Observable<UCWornLimitGenericIdNameVM[]> {
    return this._http.get<UCWornLimitGenericIdNameVM[]>(this.GET_WORN_LIMIT_MODELS).pipe(catchError(this.handleError));
  }

  public GETUCWornLimitMakes(): Observable<UCWornLimitGenericIdNameVM[]> {
    return this._http.get<UCWornLimitGenericIdNameVM[]>(this.GET_WORN_LIMIT_MAKES).pipe(catchError(this.handleError));
  }

  public GETUCWornLimitCompartTypes(): Observable<UCWornLimitGenericIdNameVM[]> {
    return this._http.get<UCWornLimitGenericIdNameVM[]>(this.GET_WORN_LIMIT_COMPART_TYPE).pipe(catchError(this.handleError));
  }

  public GETUCWornLimitComparts(): Observable<UCWornLimitGenericIdNameVM[]> {
    return this._http.get<UCWornLimitGenericIdNameVM[]>(this.GET_WORN_LIMIT_COMPARTS).pipe(catchError(this.handleError));
  }

  public GETUCWornLimitTrackTools(): Observable<UCWornLimitGenericIdNameVM[]> {
    return this._http.get<UCWornLimitGenericIdNameVM[]>(this.GET_WORN_LIMIT_TRACK_TOOL).pipe(catchError(this.handleError));
  }

  public GETUCWornLimitCalcMethods(): Observable<UCWornLimitGenericIdNameVM[]> {
    return this._http.get<UCWornLimitGenericIdNameVM[]>(this.GET_WORN_LIMIT_CALC_METHODS).pipe(catchError(this.handleError));
  }

  public GetCompartUCWornLimitData(compartId: number,toolId:number): Observable<UC_WornLimitInfoVM> {
    const options = {
      params: new HttpParams().set('compartId', compartId.toString()).set('toolId', toolId.toString())
    };
    return this._http.get<UC_WornLimitInfoVM>(this.GET_WORN_LIMIT_COMPART_INFO, options).pipe(catchError(this.handleError));
  }


  public UpdateSteppedWornLimit(model: UCStepped_ITM_WornLimitsVM): Observable<any> {
    return this._http.post(this.UPDATE_WORN_LIMIT_STEPPED_INFO, model).pipe(catchError(this.handleError));
  }

  public AddNewSteppedWornLimit(model: UCStepped_ITM_WornLimitsVM): Observable<any> {
    return this._http.post(this.ADD_NEW_WORN_LIMIT_STEPPED_INFO, model).pipe(catchError(this.handleError));
  }


  public UpdateInflectionWornLimit(model: UCInflection_CAT_WornLimitsVM): Observable<any> {
    return this._http.post(this.UPDATE_WORN_LIMIT_INFLECTION_INFO, model).pipe(catchError(this.handleError));
  }

  public AddNewInflectionWornLimit(model: UCInflection_CAT_WornLimitsVM): Observable<any> {
    return this._http.post(this.ADD_NEW_WORN_LIMIT_INFLECTION_INFO, model).pipe(catchError(this.handleError));
  }

  public UpdateLinearWornLimit(model: UCLinear_LIEBHERR_WornLimitsVM): Observable<any> {
    return this._http.post(this.UPDATE_WORN_LIMIT_LINEAR_INFO, model).pipe(catchError(this.handleError));
  }

  public AddNewLinearWornLimit(model: UCLinear_LIEBHERR_WornLimitsVM): Observable<any> {
    return this._http.post(this.ADD_NEW_WORN_LIMIT_LINEAR_INFO, model).pipe(catchError(this.handleError));
  }
  
  public UpdatePolynomialWornLimit(model: UCPolynomial_KOMATSU_WornLimitsVM): Observable<any> {
    return this._http.post(this.UPDATE_WORN_LIMIT_POLYNOMIAL_INFO, model).pipe(catchError(this.handleError));
  }

  public AddNewPolynomialWornLimit(model: UCPolynomial_KOMATSU_WornLimitsVM): Observable<any> {
    return this._http.post(this.ADD_NEW_WORN_LIMIT_POLYNOMIAL_INFO, model).pipe(catchError(this.handleError));
  }


  public PostCompartUCWornLimitInfo(model: USCOPopulateData): Observable<USCO_PartInfoVM[]> {
    return this._http.post<USCO_PartInfoVM[]>('api/UndercarriageWornLimit/PostCompartUCWornLimitInfo', model).pipe(catchError(this.handleError));
  }

  public UpdateUSCOPart(compartId: number,USCOPart:string): Observable<any> {
    const options = {
      params: new HttpParams().set('compartId', compartId.toString()).set('USCOPart', USCOPart)
    };
    return this._http.get('api/UndercarriageWornLimit/UpdateUSCOPart', options).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}
}
